import { Action as RootAction } from '@occc-app/rootRedux/action';
import { state as requestState } from '@occc-app/Offer/components/PageableRequest';

import types, { State } from './types';

export const initialState: State = {
  data: {
    offers: [],
  },
  requests: {
    offers: requestState,
  },
  paths: {
    offers: undefined,
  },
  filters: {
    search: '',
    publicationStatus: 'all',
    discontinued: 'false',
  },
};

export default function reducer(state: State = initialState, action: RootAction): State {
  switch (action.type) {
    case types.REQUEST_OFFERS:
      return {
        ...state,
        requests: { ...state.requests, offers: requestState },
      };
    case types.OFFERS_OK:
      return {
        ...state,
        requests: { ...state.requests, offers: action.request },
        data: { ...state.data, offers: action.offers },
      };
    case types.OFFERS_ERR:
      return {
        ...state,
        requests: { ...state.requests, offers: action.request },
      };
    case types.CHANGE_PATH:
      return {
        ...state,
        paths: { ...state.paths, offers: action.path },
      };
    case types.UPDATE_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.filter]: action.value,
        },
      };
    default:
      return state;
  }
}
